'use client'
import React from 'react'
import Image from 'next/image'
// const { CircularProgressbar, buildStyles } = require('react-circular-progressbar')
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import styles from './styles.module.scss'
import useGradientForProgressBar from './useGradientForProgressBar'

interface ProgressAvatarProps {
  progressPercents: number
  currentLevel: number
  statusName: string
  image: string
}
const ProgressAvatar: React.FC<ProgressAvatarProps> = ({
  progressPercents = 0,
  currentLevel,
  statusName,
  image,
}) => {
  useGradientForProgressBar(progressPercents)

  return (
    <div className={styles.container}>
      <CircularProgressbar
        value={progressPercents}
        strokeWidth={6}
        circleRatio={0.78}
        styles={buildStyles({
          rotation: 0.6085,
          strokeLinecap: 'round',
          textSize: '16px',
          pathTransitionDuration: 0.5,
          pathColor: `#3E71F4`,
          trailColor: '#000000',
        })}
      />
      <Image
        width={120}
        height={120}
        className={styles.img}
        src={image}
        alt="user"
      />
      <div>
        <div className={styles.level}>{currentLevel}</div>
        <div>{statusName}</div>
      </div>
    </div>
  )
}

export default ProgressAvatar
